import React, { useState } from "react"
import { Flex, Link, useAuthenticator } from "@aws-amplify/ui-react"
import { useConfig } from "../../configuration/useConfig"
import { GOOGLE_ISS, MICROSOFT_ISS, IdpProvider } from "../../configuration/config"
import IdpSignInButton from "./IdpSignInButton"
import GoogleSignInButton from "./GoogleSignInButton"
import MicrosoftSignInButton from "./MicrosoftSignInButton"

const SignInFooter = () => {
  const { toForgotPassword } = useAuthenticator()
  const {config} = useConfig()
  const [error, setError] = useState<string | null>(null)

  let googleProvider: IdpProvider | undefined
  const entraProviders: IdpProvider[] = []
  const customProviders: IdpProvider[] = []

  for (const p of config.idpProviders) {
    if (p.iss === GOOGLE_ISS) googleProvider = p
    else if (p.iss?.startsWith(MICROSOFT_ISS)) entraProviders.push(p)
    else customProviders.push(p)
  }

  return (
    <Flex direction="column" gap={"0.75rem"}>
      {googleProvider && (
        <GoogleSignInButton setError={setError} />
      )}
      {entraProviders.map((provider) => (
        <MicrosoftSignInButton providerName={provider.name} setError={setError} key={provider.name} />
      ))}
      {customProviders.map(provider => {
        return (
          <IdpSignInButton providerName={provider.name} setError={setError} key={provider.name}></IdpSignInButton>
      )})}
      {error ? (
        <span style={{ color: "#fff", fontSize: "0.9rem" }}>{error}</span>
      ) : null}
      <Link onClick={toForgotPassword}>Forgot your password?</Link>
    </Flex>
  )
}

export default SignInFooter
